import AuthHelper from "../modules/auth/components/auth-helper";
import { APP_DATA } from '../app.config';

const handleIdleValueChange = (e) => {
  const newIdleValue = e.newValue;
  if (newIdleValue) { // --- Active time only receives when another tab is active ---//
    APP_DATA.idleTime = 0;
  }
};

const handleStorageEvent = async (e) => {
  /** ------ Check for REFRESH_TOKEN changes -----*/
  if (e.key === 'REFRESH_TOKEN') {
    if (!!e.oldValue && e.newValue === null) {
      AuthHelper.signUserOut();
      // refrsh the page: to avoid issues due to broken page after js code errors in the app
      // todo: can be removed this when the app has handled all the exceptions
      const redirectPath = `${window.location.origin}/session-expired`;
      window.location.replace(redirectPath);
    } else if (!e.oldValue && !!e.newValue) {
      AuthHelper.signUserInSystemaAutomatically();
    }
  }
  /** ------ Listening to LAST_ACTIVE_TIME updates from other tabs -----*/
  if (e.key === 'LAST_ACTIVE_TIME') {
    handleIdleValueChange(e);
  }

  /** ------ Listening to SIGNOUT_BROADCAST from other tabs -----*/
  if (e.key === 'SIGNOUT_BROADCAST') {
    if (e.newValue) {
      try {
        const receivedValues = e.newValue.split('.');
        const messageType = receivedValues[0];
        const receivedKey = receivedValues[1];

        if (messageType === 'RESP') {
        // -- true: a response for a signout ping ---//

          if (receivedKey === APP_DATA.appKey) {
          // --- true: reply for the broadcasted ping from this app instance ---//
            AuthHelper.signoutPingResponseHandler(e.newValue);
          }
        // --- else not needed: response is not for this app instance ---//
        } else if (messageType === 'PING') {
        // signout requested from another app instance; respond..
          AuthHelper.broadcastSignoutPingResponse(receivedKey);
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
};
const addStorageEventListener = () => {
  window.addEventListener('storage', (e) => handleStorageEvent(e));
};
const removeStorageEventListener = () => {
  window.removeEventListener('storage', handleStorageEvent);
};

export default
{
  name: 'BrowserEventsHandler',
  bindEvents: () => {
    if (window.addEventListener) {
      addStorageEventListener();
    }
  },
  unbindEvents: () => {
    if (window.removeEventListener) {
      removeStorageEventListener();
    }
  },
};
